// Translate the status to french words
export function translateStatus(status = "") {
  switch (status.toLowerCase()) {
    case "pending":
      return "en attente"
    case "shipped":
      return "expédié"
    case "canceled_internally":
      return "annulé en interne"
    default:
      return status
  }
}
// Reverse status translation
export function reverseTranslateStatus(status) {
  switch (status) {
    case "manquant":
      return "missing"
    case "Retour Payé":
    case "Retour":
    case "Préparation Retour":
    case "Retour Client Agence":
    case "Retour Définitif":
    case "Retour Expéditeur":
    case "Retour Reçu":
      return "returned"
    case "Livré":
    case "Livré Payé":
    case "Payé":
      return "completed"
    default:
      return status
  }
}

// Translate account names
export function translateAccountName(name = "") {
  switch (name) {
    case "account1":
      return "Resuxi Bas Prix"
    case "account2":
      return "Layouni Commerce"
    case "account3":
      return "Société Resuxi"
    default:
      return name
  }
}
